import { readPointUserList, readSettingList } from '@/api/point/read';
import { ResReadPointUserListType } from '@/types';
import { Box, Button, Card, CardContent, Divider } from '@mui/material';
import { useEffect, useState } from 'react';
import Header from '../../Header';
import { Tables } from '../../pools/table/Tables';
import { pointUserListColumns } from '../table/ColumnData';

import { useNavigate } from 'react-router-dom';
import { packBigNumbers } from '@/lib/BigNumbers';
import { GridColDef } from '@mui/x-data-grid';

export default function PointUsers() {
  const [list, setList] = useState<ResReadPointUserListType[]>([]);
  const navigate = useNavigate();

  const addPointUserListColumns: GridColDef[] = [
    ...pointUserListColumns,
    {
      minWidth: 100,
      field: 'pointId',
      headerName: '원장',
      headerAlign: 'center',
      align: 'center',
      sortable: false,
      renderCell: (params) => (
        <Button color="primary" onClick={() => handleButtonClick(params.row.pointId)}>
          상세
        </Button>
      ),
    },
  ];
  const handleButtonClick = (aData: string) => {
    navigate('/user-detail', {
      state: {
        pointId: aData,
      },
    });
  };
  useEffect(() => {
    (async () => {
      const re = await readPointUserList();
      if (re.status !== 200) {
        return;
      }
      const list = re.data.map((item: ResReadPointUserListType, index: number) => ({
        ...item,
        index,
        totCount: packBigNumbers(item.totCount.toString()),
        totPoint: packBigNumbers(item.totPoint.toString()),
        totReferralPoint: packBigNumbers(item.totReferralPoint.toString()),
        totBonusPoint: packBigNumbers(item.totBonusPoint.toString()),
        total: packBigNumbers(item.total.toString()),
      }));
      setList(list);
      console.log(re.data);
    })();
    return () => {};
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        overflow: 'auto',
        flex: 1,
        flexDirection: 'column',
        gap: { xs: '16px', sm: '0px' },
      }}
    >
      <Card>
        <Header title="사용자 정보 리스트" />
        <Divider />
        <Box mb={2} />
        <Button
          variant="contained"
          onClick={() => {
            navigate('/excel-upload-point');
          }}
        >
          사용자 포인트 엑셀 업로드
        </Button>
        <CardContent
          sx={{
            maxHeight: 1024, // 원하는 높이(px)로 조정
            overflow: 'auto',
          }}
        >
          {list && <Tables list={list} columns={addPointUserListColumns} />}
        </CardContent>
      </Card>
    </Box>
  );
}
